<template>
  <div class="app">
    <template v-if="item">
      <Images :images="item.images" :media="media" v-if="item.images.length > 0" />

      <section :class="getClassName('headline')">
        <div :class="getClassName('headline__wrapper')">
          <h1 :class="getClassName('headline__title')">
            <span :class="getClassName('headline__category')">{{ item.category.name }}</span>
            {{ item.name }}
          </h1>
          <Favorite :form="form" :user="user" :media="media" @alert="applyAlert" @user="applyUser" />
        </div>
        <div :class="getClassName('headline__summary')" v-html="item.summary" />
      </section>

      <Purchase :item="item" :enable-cart="enableCart" :media="media" v-model="form" @alert="applyAlert" />

      <UserReviews :item="item" :user="user" :reviews="item.reviews" :media="media" @alert="applyAlert" />

      <Simulator :item="item" :media="media" v-if="enableSimulator" />

      <Alert
        :visible="alert.visible"
        :varient="alert.varient"
        :messages="alert.messages"
        :media="media"
        @hide="alert.visible = false"
      />
    </template>
    <Loading :is-show="item === null" />
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../../config/const';
import { OK, CREATED, UNPROCESSABLE_ENTITY, ERROR_MESSAGES } from '../../_modules/util';

import getClassName from '../_mixins/getClassName';
import mediaQuery from '../_mixins/mediaQuery';

import Images from './components/Images';
import Purchase from './components/Purchase';
import Alert from '../_components/Alert';
import Simulator from './components/Simulator';
import UserReviews from './components/UserReviews';
import Favorite from './components/Favorite';

import Loading from '../_components/Loading';

export default {
  mixins: [getClassName, mediaQuery],
  components: {
    Images,
    Purchase,
    Alert,
    Simulator,
    UserReviews,
    Favorite,
    Loading,
  },
  props: {
    id: {
      type: Number,
      required: false,
      default: parseInt(window.location.pathname.split('/')[3]),
    },
  },
  data() {
    return {
      user: null,
      item: null,
      payments: [],
      form: {
        item_id: this.id,
        item_color_id: null,
        item_size_id: null,
        item_option_id: null,
        quantity: 1,
        parts: [],
      },
      alert: {
        visible: false,
        varient: '',
        messages: [],
      },
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    enableSimulator() {
      return this.item.category.slug === 'curtain-madomo' || this.item.category.slug === 'mekakushi-madomo';
    },
    enableCart() {
      return this.payments.length > 0;
      //   return (
      //     this.payments.length > 0 &&
      //     this.form.item_color_id !== null &&
      //     this.form.item_size_id !== null &&
      //     this.form.item_option_id !== null
      //   );
    },
  },
  methods: {
    async fetch() {
      const response = await axios.get(API_URL + '/items/' + this.id);
      if (response.status === OK) {
        this.user = response.data.user;
        this.item = response.data.item;
        this.payments = response.data.payments.filter(
          (payment) => payment.id !== this.item.disabled_payment_id
        );
        if (this.form.item_color_id === null)
          this.form.item_color_id = this.item.colors.length > 0 ? this.item.colors[0].id : null;

        // if (this.form.item_size_id === null)
        //   this.form.item_size_id = this.item.sizes.length > 0 ? this.item.sizes[0].id : null;

        // if (this.form.item_option_id === null) {
        //   const [option] = this.item.options.filter(
        //     (option) =>
        //       option.item_color_id === parseInt(this.form.item_color_id) &&
        //       option.item_size_id === parseInt(this.form.item_size_id)
        //   );
        //   this.form.item_option_id = option ? option.id : null;
        // }

        const [option] = this.item.options.filter((option) => option.stock !== 3);
        // this.form.item_color_id = option ? option.item_color_id : null;
        this.form.item_size_id = option ? option.item_size_id : null;
        this.form.item_option_id = option ? option.id : null;

        return false;
      }

      this.alert = {
        visible: true,
        varient: 'error',
        messages: [ERROR_MESSAGES[response.status]],
      };
    },
    applyAlert(alert) {
      this.alert = { ...alert, visible: true };
    },
    applyUser(user) {
      this.user = user;
    },
  },
};
</script>

<style lang="scss">
@import '../_sass/mixins';

.app {
  min-height: 100vh;
}

.headline {
  width: 834px;
  margin: 68px auto 0;
  &--sp {
    width: 87.5%;
    margin: 26px auto 0;
  }
  &__wrapper {
    display: flex;
    align-items: center;
    &--sp {
      display: block;
    }
  }
  &__title {
    @include title;
    font-size: 2.2rem;
    letter-spacing: 0.15em;
    line-height: 1;
    &--sp {
      font-size: 1.3rem;
      letter-spacing: 0.1em;
    }
  }
  &__category {
    display: block;
    margin-bottom: 10px;
    font-size: 1.8rem;
    &--sp {
      font-size: 1.1rem;
    }
  }
  &__summary {
    margin-top: 23px;
    &--sp {
      margin-top: 16px;
      font-size: 1.1rem;
    }
    a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
